import React from 'react';

function Variant2({ activeIndex, childCount, activeIndicatorColor, inactiveIndicator }) {
  const indicatorArray = Array.from({ length: childCount });
  return (
    <div className="flex flex-row w-full items-center justify-center">
      {indicatorArray.map((element, index) => {
        return (
          <div
            style={{
              backgroundColor: activeIndex === index ? activeIndicatorColor : inactiveIndicator,
            }}
            className={`${activeIndex === index ? 'w-[20px]' : 'w-[10px]'} rounded-full m-1 h-[10px]`}
          ></div>
        );
      })}
    </div>
  );
}

export default Variant2;
